import { Checkbox, Chip } from '@mui/material';
import { Cancel } from '@mui/icons-material';
import { Body2 } from '../../themes/typography';

const options = [
    { id: 1, name: 'Checkbox 1' },
    { id: 2, name: 'Checkbox 2' },
    { id: 3, name: 'Checkbox 3' }
];

export default function MuiCheckboxChip({
    checkboxOptions = options || [],
    selectedCheckbox,
    setSelectedCheckbox
}) {
    return (
        <>
            {checkboxOptions.map(({ id, name }) => {
                // const checkboxChecked = selectedCheckbox?.find(item => item.id === id);
                const isChecked = selectedCheckbox.some(item => item.id === id);

                return (
                    <Chip
                        key={id}
                        label={
                            <Checkbox
                                disableRipple
                                disableTouchRipple
                                sx={{
                                    padding: 0,
                                    cursor: isChecked ? 'default' : 'pointer',
                                    pointerEvents: isChecked ? 'none' : 'auto',
                                    color: isChecked ? 'var(--secondary-color)' : 'var(--quaternary-color)'
                                }}
                                icon={
                                    <Body2
                                        color={isChecked ? 'var(--primary-color)' : 'var(--quaternary-color)'}
                                        fontWeight={300}
                                    >
                                        {name}
                                    </Body2>
                                }
                                checked={isChecked}
                                checkedIcon={
                                    <Body2
                                        color={isChecked ? 'var(--primary-color)' : 'var(--quaternary-color)'}
                                        fontWeight={isChecked ? 500 : 300}
                                    >
                                        {name}
                                    </Body2>
                                }
                                onChange={(event) => {
                                    if (event.target.checked) {
                                        setSelectedCheckbox((prev) => [...prev, { id, name }]);
                                    } else {
                                        setSelectedCheckbox((prev) => prev.filter((item) => item.id !== id));
                                    }
                                }}
                            />
                        }
                        onDelete={
                            isChecked
                                ? () => setSelectedCheckbox((prev) => prev.filter((item) => item.id !== id))
                                : undefined
                        }
                        deleteIcon={<Cancel />}
                        sx={{
                            border: '1px solid var(--secondary-color)',
                            backgroundColor: isChecked ? 'var(--secondary-color)' : 'transparent',
                            color: 'white',
                            width: 'auto',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: '10px',
                            padding: '5px 10px',
                            '& .MuiChip-deleteIcon': {
                                width: 'auto',
                                color: 'var(--primary-color)',
                                fontSize: '1.175rem',
                                margin: '0px',
                                borderRadius: '50%',
                                transition: 'all 0.2s'
                            },
                            '& .MuiChip-deleteIcon: hover': {
                                color: 'white'
                            },
                            '& .MuiChip-label': {
                                color: 'var(--primary-color)',
                                padding: '0px',
                                margin: '0px'
                            }
                        }}
                    />
                );
            })}
        </>
    );
}